import { useCallback } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { INACTIVITY_TIMEOUT, PROMPT_BEFORE_IDLE_TIMEOUT } from '@/consts';
import { useModalState } from './useModalState';

const timeout = INACTIVITY_TIMEOUT;
const promptBeforeIdle = PROMPT_BEFORE_IDLE_TIMEOUT;

// TODO Copied from UM: please move this to a shared location e.g. fe-common
const useSessionTimeout = (logout: () => void) => {
  const [isOpenLogOut, openLogOutModal, closeLogOutModal] = useModalState(false);

  const onIdle = useCallback(() => {
    logout();
  }, [logout]);

  const onPrompt = useCallback(() => {
    openLogOutModal();
  }, [openLogOutModal]);

  const { reset } = useIdleTimer({
    onIdle,
    onPrompt,
    timeout,
    promptBeforeIdle,
    throttle: 500,
  });

  const onResetSession = useCallback(() => {
    reset();
    closeLogOutModal();
  }, [reset, closeLogOutModal]);

  return {
    isOpenLogOut,
    onResetSession,
  };
};

export default useSessionTimeout;
